import {
  CLAIMS_PROCESSED_REQUEST,
  CLAIMS_PROCESSED_SUCCESS,
  CLAIMS_PROCESSED_FAILURE,
  CLAIMS_PROCESSED_LOADING,
  CLAIMS_METRICS_EXCLUSION_REQUEST,
  CLAIMS_METRICS_EXCLUSION_SUCCESS,
  CLAIMS_METRICS_EXCLUSION_FAILURE,
  CLAIMS_METRICS_EXCLUSION_LOADING,
  DOP_CLAIMS_METRICS_CLAIMS_REQUEST,
  DOP_CLAIMS_METRICS_CLAIMS_SUCCESS,
  DOP_CLAIMS_METRICS_CLAIMS_FAILURE,
  DOP_CLAIMS_METRICS_CLAIMS_LOADING,
  DOP_CLAIMS_METRICS_TAT_REQUEST,
  DOP_CLAIMS_METRICS_TAT_SUCCESS,
  DOP_CLAIMS_METRICS_TAT_FAILURE,
  DOP_CLAIMS_METRICS_TAT_LOADING,
  CLAIMS_PROCESSED_MONTHLY_REQUEST,
  CLAIMS_PROCESSED_MONTHLY_SUCCESS,
  CLAIMS_PROCESSED_MONTHLY_FAILURE,
  CLAIMS_PROCESSED_MONTHLY_LOADING,
  CLAIMS_PROCESSED_LOB_REQUEST,
  CLAIMS_PROCESSED_LOB_SUCCESS,
  CLAIMS_PROCESSED_LOB_FAILURE,
  CLAIMS_PROCESSED_LOB_LOADING,
} from '../actionTypes';

export const fetchClaimsProcessedRequest = (payload: any, highVolumeTinFlag?: boolean) => ({
  type: CLAIMS_PROCESSED_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchClaimsProcessedSuccess = (payload: any) => ({
  type: CLAIMS_PROCESSED_SUCCESS,
  payload,
});

export const fetchClaimsProcessedError = (payload: any) => ({
  type: CLAIMS_PROCESSED_FAILURE,
  payload,
});

export const fetchClaimsProcessedLoading = (payload: any) => ({
  type: CLAIMS_PROCESSED_LOADING,
  payload,
});

export const fetchClaimsMetricsExclusionRequest = (payload: any, highVolumeTinFlag?: boolean) => ({
  type: CLAIMS_METRICS_EXCLUSION_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchClaimsMetricsExclusionSuccess = (payload: any) => ({
  type: CLAIMS_METRICS_EXCLUSION_SUCCESS,
  payload,
});

export const fetchClaimsMetricsExclusionError = (payload: any) => ({
  type: CLAIMS_METRICS_EXCLUSION_FAILURE,
  payload,
});

export const fetchClaimsMetricsExclusionLoading = (payload: any) => ({
  type: CLAIMS_METRICS_EXCLUSION_LOADING,
  payload,
});

export const fetchDopClaimsMetricsClaimsRequest = (payload: any, highVolumeTinFlag?: boolean) => ({
  type: DOP_CLAIMS_METRICS_CLAIMS_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchDopClaimsMetricsClaimsSuccess = (payload: any) => ({
  type: DOP_CLAIMS_METRICS_CLAIMS_SUCCESS,
  payload,
});

export const fetchDopClaimsMetricsClaimsError = (payload: any) => ({
  type: DOP_CLAIMS_METRICS_CLAIMS_FAILURE,
  payload,
});

export const fetchDopClaimsMetricsClaimsLoading = (payload: any) => ({
  type: DOP_CLAIMS_METRICS_CLAIMS_LOADING,
  payload,
});

export const fetchDopClaimsMetricsTatRequest = (payload: any, highVolumeTinFlag?: boolean) => ({
  type: DOP_CLAIMS_METRICS_TAT_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchDopClaimsMetricsTatSuccess = (payload: any) => ({
  type: DOP_CLAIMS_METRICS_TAT_SUCCESS,
  payload,
});

export const fetchDopClaimsMetricsTatError = (payload: any) => ({
  type: DOP_CLAIMS_METRICS_TAT_FAILURE,
  payload,
});

export const fetchDopClaimsMetricsTatLoading = (payload: any) => ({
  type: DOP_CLAIMS_METRICS_TAT_LOADING,
  payload,
});

export const fetchClaimsProcessedMonthlyRequest = (payload: any, highVolumeTinFlag?: boolean) => ({
  type: CLAIMS_PROCESSED_MONTHLY_REQUEST,
  payload,
  highVolumeTinFlag,
});

export const fetchClaimsProcessedMonthlySuccess = (payload: any) => ({
  type: CLAIMS_PROCESSED_MONTHLY_SUCCESS,
  payload,
});

export const fetchClaimsProcessedMonthlyError = (payload: any) => ({
  type: CLAIMS_PROCESSED_MONTHLY_FAILURE,
  payload,
});

export const fetchClaimsProcessedMonthlyLoading = (payload: any) => ({
  type: CLAIMS_PROCESSED_MONTHLY_LOADING,
  payload,
});

export const fetchClaimsProcessedLobRequest = (payload: any) => ({
  type: CLAIMS_PROCESSED_LOB_REQUEST,
  payload,
});

export const fetchClaimsProcessedLobSuccess = (payload: any) => ({
  type: CLAIMS_PROCESSED_LOB_SUCCESS,
  payload,
});

export const fetchClaimsProcessedLobError = (payload: any) => ({
  type: CLAIMS_PROCESSED_LOB_FAILURE,
  payload,
});

export const fetchClaimsProcessedLobLoading = (payload: any) => ({
  type: CLAIMS_PROCESSED_LOB_LOADING,
  payload,
});